import { Injectable, signal } from '@angular/core';

import { TaskModel } from '@core/models/task.model';

export interface DragData {
  task: TaskModel;
  sourceElement: HTMLElement;
}

@Injectable({
  providedIn: 'root',
})
export class DragDropService {
  private readonly dragData = signal<DragData | null>(null);
  private readonly isDragging = signal<boolean>(false);

  readonly currentDragData = this.dragData.asReadonly();
  readonly isCurrentlyDragging = this.isDragging.asReadonly();

  startDrag(task: TaskModel, sourceElement: HTMLElement): void {
    this.dragData.set({ task, sourceElement });
    this.isDragging.set(true);

    // Добавляем визуальные эффекты
    sourceElement.classList.add('task-dragging');
    document.body.classList.add('drag-in-progress');
  }

  endDrag(): void {
    const currentData = this.dragData();
    if (currentData) {
      currentData.sourceElement.classList.remove('task-dragging');
    }

    document.body.classList.remove('drag-in-progress');
    this.dragData.set(null);
    this.isDragging.set(false);
  }

  getDraggedTask(): TaskModel | null {
    return this.dragData()?.task || null;
  }
}
